import React from 'react';
import { Route } from 'react-router-dom';
import {
  clientRouterHubLocales,
  LOCALE_ROUTE_PREFIX,
} from '../config/localeRoutes';

type LocalizedServicesRoutesProps = {
  MetierLanding: React.ComponentType;
  MetierCityLanding: React.ComponentType;
  ServicesHubPage: React.ComponentType;
};

/**
 * Éléments <Route> à spread dans <Routes> (React Router v6 n'accepte pas
 * un composant wrapper — seulement <Route> ou <Fragment> en enfants directs).
 */
export function localizedServicesRouteElements({
  MetierLanding,
  MetierCityLanding,
  ServicesHubPage,
}: LocalizedServicesRoutesProps): React.ReactNode[] {
  return clientRouterHubLocales().flatMap((locale) => {
    const prefix = `${LOCALE_ROUTE_PREFIX[locale]}/services`;
    return [
      <Route key={`${locale}-hub`} path={prefix} element={<ServicesHubPage />} />,
      <Route key={`${locale}-hub-slash`} path={`${prefix}/`} element={<ServicesHubPage />} />,
      <Route
        key={`${locale}-city`}
        path={`${prefix}/:metierSlug/:citySlug`}
        element={<MetierCityLanding />}
      />,
      <Route key={`${locale}-slug`} path={`${prefix}/:slug`} element={<MetierLanding />} />,
    ];
  });
}
